import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import VideoWebcamRecorder from './Recorder';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import loading from './../../loading-gif-png-5.gif';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const Record = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [recording, setRecording] = useState(false);
  const [takingVideo, setTakingVideo] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [numVideo, setNumVideo] = useState(0);

  const [numConversation1, setNumConversation1] = useState(0);
  const [instruction, setInstruction] = useState('');
  const [voice, setVoice] = useState('');
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const [playVideo, setPlayVideo] = useState('');
  const [videos, setVideos] = useState([]);
  const [displayInfluencer, setDisplayInfluencer] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [example, setExample] = useState(false);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')

  const [displayIntroVideo, setDisplayIntroVideo] = useState(true);
  const [displayBullying, setDisplayBullying] = useState(false);

  const videoPlayer1 = {
    width: '370px',
    height: '655px',
    zIndex: 20,
  };

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  const Exit = generateImageUrl('images/Images/close.png')

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  useEffect(() => {
    if(recording) {
        setupGame();
    }
  }, [numVideo, recording]);

  useEffect(() => {
    if(recording) {
        displayConversation();
    }
  }, [numConversation1]);

  async function setupGame() {
    if (numVideo < props.names.length) {
      setInstruction(await getVideo(props.instructions[numVideo], login));
      if(props.voices){
        setVoice(await getVideo(props.voices[numVideo], login));
      }
      setTakingVideo(true);
    } else {
      (async () => {
        dispatch({
          type: `FREEPLAY_SET_${props.level}_${props.conversation}_${props.topic}`,
          payload: 1,
        });
        setAnimalVoice(await getVideo(props.practiceMessageAudio, login));
        await GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`).then((data) => {
          setInfluencerVideo(data);
        });
        setAnimateAnimal(props.practiceMessage);
        setDisplayAnimal(true);
        
      })();
    }
  }

  async function displayConversation() {
    if (numConversation1 <= props.names.length - 1) {
      setInstruction(await getVideo(props.instructions[numConversation1], login));
      // await GetUserVideo(
      //   `userfiles/${login.studentid}/${props.names[numConversation1]}`
      // ).then((data) => {
      //   setPlayVideo(data);
      //   setConversation1(true);
      // });
      setPlayVideo(videos[numConversation1]);
      setConversation1(true);
    } else {
      setInstruction(await getVideo(props.instructions[numConversation1], login));
      setConversation1(true);
    }
  }

  // The HTML code for the practice
  return (
    <>
      {displayIntroVideo && (
          <CloudfrontVideoFormat
              source={'ae17b215c914c6dd97c61e0c9b76/480.m3u8'}
              close={props.setDisplayPractice}
              ended={() => {
                  setDisplayIntroVideo(false);
                  if(props.exampleVideo){
                    setExample(true)
                  }
                  else{
                    setRecording(true);
                  }                    
              }}
          />
      )}
      {example && (
        <CloudfrontVideoFormat
          source={props.exampleVideo}
          close={props.setDisplayPractice}
          ended={() => {
            setExample(false);
            setRecording(true);            
          }}
      />)}
      {displayAudio && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayAudio(false);
            setDisplayAnimal(false);
            if (animateAnimal === props.practiceMessage) {
              setDisplayInfluencer(true);
            } else if (animateAnimal === props.practiceConversation) {
              displayConversation();
            } else if (animateAnimal === props.awesomeJob) {
              props.finish();
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {recording && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice();
            }}
          ></img>
          {takingVideo && (
            <VideoWebcamRecorder
              background={props.background}
              instruction={instruction}
              outputText={props.texts[numVideo]}
              name={props.names[numVideo]}
              voice={voice}
              close={props.setDisplayPractice}
              videos={videos}
              setVideos={setVideos}
              ended={() => {
                setNumVideo(numVideo + 1);
                setTakingVideo(false);
              }}
            />
          )}
          {displayBullying && (
            <VideoWebcamRecorder
              background={props.background}
              instruction={generateImageUrl('media/Freeplay/bullying_practice_intro.mp4')}
              outputText={`Press record and say the three steps to stop bullying, “Step 1: Tell the bully to stop. Step 2: Walk away and stay away. Step 3: Tell a safe adult.”`}
              name={"level1_friends_bullying.mp4"}
              voice={generateImageUrl('media/Freeplay/bullying_practice_prompt.m4a')}
              recording={true}
              close={props.setDisplayPractice}
              ended={() => {
                setAnimateAnimal(props.awesomeJob);
                setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                setDisplayAnimal(true);
              }}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {displayAnimal && (
            <img
              className={animalSize}
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
          {displayInfluencer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                onEnded={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                onError={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation1 && (
            <div id='borderVideo'>
              <video
                id='record-video'
                autoPlay
                onEnded={() => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    if(props.conversation === 'FRIENDS'){
                      setDisplayBullying(true)
                    }
                    else{
                      setAnimateAnimal(props.awesomeJob);
                      setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                      setDisplayAnimal(true);
                    }
                  } else {
                    setConversation2(true);
                  }
                }}
                onError={() => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    if(props.conversation === 'FRIENDS'){
                      setDisplayBullying(true)
                    }
                    else{
                      setAnimateAnimal(props.awesomeJob);
                      setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                      setDisplayAnimal(true);
                    }
                  } else {
                    setConversation2(true);
                  }
                }}
                playsInline
              >
                <source src={instruction} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation2 && (
            <div id='border'>
              <video
                id='record-video'
                autoPlay
                onEnded={() => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    if(props.conversation === 'FRIENDS'){
                      setDisplayBullying(true)
                    }
                    else{
                      setAnimateAnimal(props.awesomeJob);
                      setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                      setDisplayAnimal(true);
                    }
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                onError={() => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    if(props.conversation === 'FRIENDS'){
                      setDisplayBullying(true)
                    }
                    else{
                      setAnimateAnimal(props.awesomeJob);
                      setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                      setDisplayAnimal(true);
                    }
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
        </div>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
    </>
  );
};
export default Record;
